import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './styles.css'
import App from './App'
import Things from './pages/Things'
import Cube from './pages/Cube'
import Prefix from './pages/Prefix'
import Ironkeep from './pages/Ironkeep'
createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/things" element={<Things />} />
      <Route path="/cube" element={<Cube />} />
      <Route path="/prefix" element={<Prefix />} />
      <Route path="/ironkeep" element={<Ironkeep />} />
    </Routes>
  </BrowserRouter>
)
